export default [
  {
    type: 'radio',
    name: 'firstHomeBuyers',
    namePrismic: 'Property - First Home Buyers Grant',
    slug: 'property-first-home-buyers-grant',
    options: [{ text: 'Yes' }, { text: 'No' }, { text: 'Not sure' }],
  },
];
